// Cubenz Charger Images - White Labeled for MILE PLUS
export const CHARGER_IMAGES = {
  // AC Chargers
  ac: {
    smartSwitch3kW: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/z78367b2_3.3kW%20Smart%20Switch%20AC%20Charger.jpeg",
    zeus7kW: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/xe95k664_Zeus7.4kW%20AC%20Charger.jpeg",
    zeus11kW: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/qqucvi1h_Zeus%2011kW%20AC%20Charger.png",
    zeus15kW: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/72me7uzr_Zeus%2015kW%20AC%20Charger.jpeg",
    zeus22kW: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/kwgqnm6f_Zeus%2022kW%20AC%20Charger%20%282%29.jpeg",
  },
  // DC Fast Chargers
  dc: {
    zeus60kW: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/e2oi8ig0_Zeus%2060kW%20DC%20Charger.jpeg",
    zeus120kW: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/xcduwhqz_Zeus%20120kW%20DC%20Charger.jpeg",
    zeus180kW: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/o09ym858_Zeus%20180kW%20DC%20Charger.jpeg",
    zeus240kW: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/u3ha37sr_Zeus%20240kW%20DC%20Charger.jpeg",
  },
  // Installation Gallery
  installations: {
    ahmedabad: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/cuxwpi7b_Installation%201.jpeg",
    bangalore1: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/1uigvgml_Installation2.jpg",
    bangalore2: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/9dk1i85f_Installation%203.jpg",
    pune: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/r9fv0x1l_Installation%204.jpeg",
    noida: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/6wv9gx1a_Installation%206.jpeg",
    highway: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/az690lgv_Installation.jpeg",
  },
  // Manufacturing
  manufacturing: {
    assemblyLine: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/bblf3fge_Manufacturing.jpg",
    productionFloor: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/k02d7w8m_Manufacturing%20%282%29.jpg",
    rdFacility: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/p9t08qzz_R%26D.jpg",
    factory1: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/vr1t1g7b_Manufacturing%20Unit.jpeg",
    factory2: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/ra3dw359_Manufacturing%20Unit%20%282%29.jpeg",
  },
  // Hero/Banner Images
  hero: {
    main: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/3gkryc4u_Front%20Page%20pic%20.jpeg",
    smartTech: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/a241vt2w_IMG-20251206-WA0020.jpg",
    showcase: "https://customer-assets.emergentagent.com/job_doc-facelift-1/artifacts/1eg799zf_Screenshot_20251214_153223_Gallery.jpg",
  },
};

// Charger product data
export const CHARGER_PRODUCTS = {
  ac: [
    {
      name: "Smart Switch",
      power: "3.3 kW",
      image: CHARGER_IMAGES.ac.smartSwitch3kW,
      description: "Compact home charger",
      price: "25,000",
    },
    {
      name: "Zeus AC",
      power: "7.4 kW",
      image: CHARGER_IMAGES.ac.zeus7kW,
      description: "Residential & Office",
      price: "45,000",
    },
    {
      name: "Zeus AC Pro",
      power: "11 kW",
      image: CHARGER_IMAGES.ac.zeus11kW,
      description: "Commercial grade",
      price: "65,000",
    },
    {
      name: "Zeus AC Plus",
      power: "22 kW",
      image: CHARGER_IMAGES.ac.zeus22kW,
      description: "Dual-gun option",
      price: "1,20,000",
    },
  ],
  dc: [
    {
      name: "Zeus DC Fast",
      power: "60 kW",
      image: CHARGER_IMAGES.dc.zeus60kW,
      description: "Commercial & Public",
      chargingTime: "45-60 min",
      price: "12,00,000",
    },
    {
      name: "Zeus DC Ultra",
      power: "120 kW",
      image: CHARGER_IMAGES.dc.zeus120kW,
      description: "Highway & Fleet",
      chargingTime: "25-35 min",
      price: "18,00,000",
    },
    {
      name: "Zeus DC Super",
      power: "180 kW",
      image: CHARGER_IMAGES.dc.zeus180kW,
      description: "Ultra-fast charging",
      chargingTime: "15-25 min",
      price: "24,00,000",
    },
    {
      name: "Zeus DC Max",
      power: "240 kW",
      image: CHARGER_IMAGES.dc.zeus240kW,
      description: "Maximum power",
      chargingTime: "10-20 min",
      price: "32,00,000",
    },
  ],
};

export default CHARGER_IMAGES;
